<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <SiliconForm :station-id="stationId" :table-url="tableUrl"></SiliconForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import SiliconForm from "@/components/silicon/SiliconForm.vue";

const stationId = 36;
const viewName = "Silicon";
const tableUrl = `/Material/GetLastSilicon?num=6`;

onMounted(() => {
  document.title = viewName;
});
</script>
